
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"50","height":"54","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.312 16.198c.034-.023 3.491-.034 10.371-.034h10.32l.994 2.314.497 1.183c.183.434.315.749.395.943.091.194.154.32.188.377h-.686l-.12-.24a5.79 5.79 0 00-.96-1.337 6.385 6.385 0 00-1.268-.96c-1.28-.777-3.086-1.24-5.417-1.389-.56-.034-2.572-.057-6.035-.068H9.587l.137.189c5.291 7.234 7.949 10.885 7.971 10.954.012.023.012.057 0 .103l-9.051 10.32c0 .011 1.206.017 3.617.017 4.857 0 7.48-.012 7.869-.035 1.565-.08 2.771-.222 3.617-.428 1.68-.411 2.994-1.177 3.943-2.297.24-.309.474-.72.703-1.235h.685c-.034.07-.394 1.04-1.08 2.915l-.994 2.657-10.303.017c-6.88 0-10.337-.011-10.371-.034-.069-.023-.103-.075-.103-.155 0-.022.011-.057.034-.102l.6-.669c.389-.457.966-1.126 1.732-2.006.765-.868 1.52-1.72 2.262-2.554 3.04-3.463 4.555-5.206 4.543-5.228 0-.012-.188-.27-.566-.772-.377-.514-.982-1.337-1.817-2.468-.822-1.143-1.56-2.16-2.211-3.052l-4.56-6.257-.017-.257c0-.24.028-.377.086-.412z","fill":"#000C1F"}}),_c('rect',{attrs:{"x":"12.152","y":"44.664","width":"11","height":"8","rx":"1.5","stroke":"#000C1F","stroke-dasharray":"4 4"}}),_c('rect',{attrs:{"x":"33.577","y":"21.164","width":"15","height":"11","rx":"1.5","stroke":"#000C1F","stroke-dasharray":"4 4"}})])
          )
        }
      }
    